<template>
  <div class="campaign-filter">
    <div layout="row" layout-align="end-center">
      <el-button
        class="campaign-filter-button"
        @click="toggleShowCampaignFilter"
        ref="campaignFilterButton"
        type="text"
      >
        <template v-if="!showCampaignFilter">
          <span>
            キャンペーン検索&nbsp;
            <i class="mdi mdi-arrow-down-drop-circle-outline" />
          </span>
        </template>
        <template v-else>
          <span>
            キャンペーン検索を終了&nbsp;
            <i class="mdi mdi-arrow-up-drop-circle-outline" />
          </span>
        </template>
      </el-button>
    </div>
    <transition name="slide">
      <div class="campaign-filter-container card" v-if="showCampaignFilter" layout="column">
        <div class="campaign-filter-row mb-x3" layout="row">
          <!-- SNS絞り込み -->
          <select-form
            :label="'SNS種類'"
            :value="targetSns"
            :options="targetSnsOptions"
            :onChange="updateTargetSnsValue"
            :disabled="account.target_sns !== undefined"
            class="campaign-filter-input-element has-max-width-pulldown"
          />

          <!-- アカウント絞り込み -->
          <div layout="column">
            <div class="campaign-filter-input-label">実施アカウント</div>
            <el-dropdown
              trigger="click"
              @command="account = $event"
              class="campaign-filter-input-element has-max-width-pulldown"
            >
              <span class="campaign-filter-account-dropdown-link">
                <Account
                  v-if="account.target_sns"
                  :name="account.name"
                  :image="account.picture_url"
                  :symbol="account.target_sns"
                />
                <span v-else>指定なし</span>
                <Icon name="menu-down" space="left" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="accountItem of filteredAccounts" :key="accountItem.key" :command="accountItem">
                  <div class="campaign-filter-account-dropdown-item">
                    <Account
                      :name="accountItem.name"
                      :image="accountItem.picture_url"
                      :symbol="accountItem.target_sns"
                    />
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <!-- キャンペーンタイプ絞り込み -->
          <select-form
            :label="'キャンペーンタイプ'"
            :value="campaignType"
            :options="campaignTypeOptions"
            :onChange="updateCampaignTypeValue"
            :disabled="campaignTypeDisabled"
            class="campaign-filter-input-element has-max-width-pulldown"
          />

          <!-- 応募条件絞り込み（複数選択） -->
          <div layout="column">
            <div class="campaign-filter-input-label">応募条件</div>
            <el-select
              v-model="entryActionTypes"
              multiple
              collapse-tags
              :disabled="entryActionDisabled"
              placeholder="指定なし"
              class="campaign-filter-input-element has-max-width-entry-action"
            >
              <el-option v-for="opt in entryActionOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
            </el-select>
          </div>

          <!-- タイトル絞り込み -->
          <div layout="column">
            <div class="campaign-filter-input-label">キャンペーンタイトル</div>
            <el-input
              class="campaign-filter-input-element title"
              type="text"
              v-model="title"
              @change="updateTitleValue"
              :placeholder="'検索(部分一致 可)'"
            >
              <template slot="prepend"><i class="mdi mdi-magnify"></i></template>
            </el-input>
          </div>

          <!-- ステータス絞り込み -->
          <select-form
            class="campaign-filter-input-element has-max-width-pulldown"
            :label="'ステータス'"
            :value="status"
            :options="statusOptions"
            :onChange="updateStatusValue"
          />
        </div>

        <!-- 日時絞り込み -->
        <div class="mb-x3" layout="row">
          <div layout="column">
            <div class="campaign-filter-input-label">キャンペーン開始日時</div>
            <div layout="row" class="campaign-filter-row">
              <el-date-picker
                v-model="startDate"
                :value="startDate"
                :editable="false"
                :picker-options="startDatePickerOptions"
                placeholder="開始日"
                prefix-icon="mdi mdi-calendar-today"
                type="date"
                value-format="yyyy-MM-dd"
              />

              <el-time-select
                v-model="startTime"
                :value="startTime"
                :editable="false"
                :picker-options="timePickerOptions"
                placeholder="開始時間"
                prefix-icon="mdi mdi-clock"
              />
              <span class="campaign-filter-date-time-label-suffix">以降</span>
            </div>
            <div class="campaign-filter-date-time-validation-message">{{ startDatetimeValidationMessage }}</div>
          </div>

          <div layout="column">
            <div class="campaign-filter-input-label">キャンペーン終了日時</div>
            <div layout="row" class="campaign-filter-row">
              <el-date-picker
                v-model="endDate"
                :value="endDate"
                :editable="false"
                :picker-options="endDatePickerOptions"
                placeholder="終了日"
                prefix-icon="mdi mdi-calendar-today"
                type="date"
                value-format="yyyy-MM-dd"
                class="campaign-filter-input-element"
              />
              <el-time-select
                v-model="endTime"
                :value="endTime"
                :editable="false"
                :picker-options="timePickerOptions"
                placeholder="終了時間"
                prefix-icon="mdi mdi-clock"
                class="campaign-filter-input-element"
              />
              <span class="campaign-filter-date-time-label-suffix">未満</span>
            </div>
            <div class="campaign-filter-date-time-validation-message">{{ endDatetimeValidationMessage }}</div>
          </div>
        </div>

        <div layout layout-align="end-center" class="campaign-filter-action-row">
          <el-button plain @click="clearSearch"> <i class="mdi mdi-reload"></i>クリア </el-button>
          <el-button type="primary" @click="searchCampaign" :disabled="!isEnabledSearchButton">
            <i class="mdi mdi-magnify"></i>検索
          </el-button>
        </div>
      </div>
    </transition>
  </div>
</template>
<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import moment from 'moment-timezone'
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'
import { z } from 'zod'

import Icon from '@/client/components/_atoms/Icon.vue'
import SelectForm from '@/client/components/_atoms/select_form/'
import Account from '@/client/components/_molecules/Account.vue'
import { CAMPAIGN_TYPES, INSTAGRAM_CAMPAIGN_TYPES, TIKTOK_CAMPAIGN_TYPES_OPTIONS } from '@/client/constant'
import { TrackingService } from '@/client/services'
import { useCampaignAccountStore } from '@/client/store/useCampaignAccountStore'
import { useCampaignStore } from '@/client/store/useCampaignStore'
import { useSystemStore } from '@/client/store/useSystemStore'
import { getEntryActionOptions } from '@/client/utils/campaign_entry_action_label'
import { hasSearchConditions, parseAllowedEntryActionTypes } from '@/client/utils/campaign_query_params'
import {
  CampaignStatusType,
  CampaignStatusTypeSchema,
  CampaignTargetSnsType,
  CampaignTargetSnsTypeSchema,
  CampaignType,
  CampaignTypeSchema
} from '@/typings/campaigns'

const dateSchema = z
  .object({
    startDate: z.string().optional().nullable(),
    startTime: z.string().optional().nullable(),
    endDate: z.string().optional().nullable(),
    endTime: z.string().optional().nullable()
  })
  .refine(data => !((data.startDate && !data.startTime) || (!data.startDate && data.startTime)), {
    path: ['startDatetime'],
    message: '日付と時間の両方を入力してください'
  })
  .refine(data => !(data.endDate && data.endTime && !data.startDate && !data.startTime), {
    path: ['startDatetime'],
    message: '開始日時を入力してください'
  })
  .refine(data => !((data.endDate && !data.endTime) || (!data.endDate && data.endTime)), {
    path: ['endDatetime'],
    message: '日付と時間の両方を入力してください'
  })
  .refine(data => !(data.startDate && data.startTime && !data.endDate && !data.endTime), {
    path: ['endDatetime'],
    message: '終了日時を入力してください'
  })
  .refine(
    data => {
      if (data.startDate && data.startTime && data.endDate && data.endTime) {
        const start = moment(`${data.startDate} ${data.startTime}`, 'YYYY-MM-DD HH:mm')
        const end = moment(`${data.endDate} ${data.endTime}`, 'YYYY-MM-DD HH:mm')
        return end.isAfter(start)
      }
      return true
    },
    {
      path: ['endDatetime'],
      message: '終了日時は開始日時より後に設定してください'
    }
  )
  .refine(
    data => {
      if (data.startDate && data.startTime && data.endDate && data.endTime) {
        const start = moment(`${data.startDate} ${data.startTime}`, 'YYYY-MM-DD HH:mm')
        const end = moment(`${data.endDate} ${data.endTime}`, 'YYYY-MM-DD HH:mm')
        const sixMonthsLater = moment(start).add(6, 'months')
        return end.isSameOrBefore(sixMonthsLater)
      }
      return true
    },
    {
      path: ['endDatetime'],
      message: '日付範囲は6ヶ月以内で設定してください'
    }
  )

interface RestoredFilterState {
  title: string
  status: string | undefined
  targetSns: CampaignTargetSnsType | undefined
  campaignType: CampaignType | null
  entryActionTypes: string[]
}

/**
 * URL クエリから検索フォームの新しい状態を計算する純粋関数。
 */
function extractFormStateFromQuery(query: Record<string, string | string[] | undefined | null>): RestoredFilterState {
  const statusResult = CampaignStatusTypeSchema.safeParse(query.status)
  const status = statusResult.success ? statusResult.data : undefined

  const targetSnsResult = CampaignTargetSnsTypeSchema.safeParse(query.targetSns)
  const targetSns = targetSnsResult.success ? targetSnsResult.data : undefined

  const campaignTypeResult = CampaignTypeSchema.safeParse(query.campaignType)
  const campaignType = campaignTypeResult.success ? campaignTypeResult.data : null

  const entryActionTypes =
    typeof query.entryActionTypes === 'string'
      ? parseAllowedEntryActionTypes(targetSns, campaignType ?? undefined, query.entryActionTypes)
      : []

  return {
    title: typeof query.title === 'string' ? query.title : '',
    status,
    targetSns,
    campaignType,
    entryActionTypes
  }
}

export default defineComponent({
  components: {
    Icon,
    Account,
    SelectForm
  },
  data() {
    return {
      showCampaignFilter: false,
      account: {},
      accounts: [],
      title: '',
      status: undefined,
      targetSns: undefined,
      startDate: undefined,
      endDate: undefined,
      startTime: undefined,
      endTime: undefined,
      startDatetimeValidationMessage: '',
      endDatetimeValidationMessage: '',
      campaignType: null,
      entryActionTypes: [],
      isLoadingFormFromQuery: false
    }
  },
  computed: {
    ...mapState(useSystemStore, {
      currentGroupId: state => state.currentGroup?.id ?? null
    }),
    ...mapState(useCampaignAccountStore, {
      apiAccounts: state => state.api_accounts
    }),
    targetSnsOptions() {
      return [
        {
          label: '指定なし',
          value: undefined
        },
        {
          label: 'X',
          value: 'twitter'
        },
        {
          label: 'Instagram',
          value: 'instagram'
        },
        {
          label: 'TikTok',
          value: 'tiktok'
        }
      ]
    },
    statusOptions() {
      return [
        {
          label: '指定なし',
          value: undefined
        },
        {
          label: '開催前',
          value: CampaignStatusType.BEFORE_EVENT
        },
        {
          label: '開催中',
          value: CampaignStatusType.DURING_COLLECTION
        },
        {
          label: '開催終了',
          value: CampaignStatusType.COLLECTION_COMPLETED
        }
      ]
    },
    filteredAccounts() {
      return this.accounts.filter(account => {
        if (this.targetSns && !this.account.target_sns) {
          return account.target_sns === this.targetSns || account.name === '指定なし'
        }
        return true
      })
    },
    startDatetime() {
      return this.startDate && this.startTime
        ? moment(`${this.startDate} ${this.startTime}`).format('YYYY-MM-DD-HH-mm')
        : undefined
    },
    endDatetime() {
      return this.endDate && this.endTime
        ? moment(`${this.endDate} ${this.endTime}`).format('YYYY-MM-DD-HH-mm')
        : undefined
    },
    startDatePickerOptions() {
      return {
        disabledDate: date => {
          if (!this.endDate) return false

          const targetDate = moment(date.getTime())
          const endDate = moment(this.endDate)
          const sixMonthAgo = moment(moment(this.endDate).subtract(6, 'months').startOf('day'))

          return targetDate.isAfter(endDate) || targetDate.isBefore(sixMonthAgo)
        }
      }
    },
    endDatePickerOptions() {
      return {
        disabledDate: date => {
          if (!this.startDate) return false

          const targetDate = moment(date.getTime())
          const startDate = moment(this.startDate)
          const sixMonthLater = moment(this.startDate).add(6, 'months').endOf('day')

          return targetDate.isBefore(startDate) || targetDate.isAfter(sixMonthLater)
        }
      }
    },
    timePickerOptions() {
      return {
        start: '00:00',
        step: '01:00',
        end: '23:00'
      }
    },
    validationDatetime() {
      const result = dateSchema.safeParse({
        startDate: this.startDate,
        startTime: this.startTime,
        endDate: this.endDate,
        endTime: this.endTime
      })

      this.startDatetimeValidationMessage = ''
      this.endDatetimeValidationMessage = ''

      if (result.success) {
        return
      }

      if (result?.error?.issues[0]?.path[0] === 'startDatetime') {
        this.startDatetimeValidationMessage = result.error.issues[0].message
      }
      if (result?.error?.issues[0]?.path[0] === 'endDatetime') {
        this.endDatetimeValidationMessage = result.error.issues[0].message
      }
    },
    isEnabledSearchButton() {
      return this.startDatetimeValidationMessage === '' && this.endDatetimeValidationMessage === ''
    },
    /**
     * キャンペーンタイプの選択肢を生成.
     */
    campaignTypeOptions() {
      const defaultOption = { label: '指定なし', value: null }

      switch (this.targetSns) {
        case 'twitter':
          return [defaultOption, ...CAMPAIGN_TYPES, { label: 'インスタントウィン', value: 'instantwin' }]

        case 'instagram':
          return [defaultOption, ...INSTAGRAM_CAMPAIGN_TYPES]

        case 'tiktok':
          return [defaultOption, ...TIKTOK_CAMPAIGN_TYPES_OPTIONS]

        default:
          return [defaultOption]
      }
    },
    /**
     * 応募条件プルダウンの選択肢を生成.
     */
    entryActionOptions() {
      if (!this.targetSns || !this.campaignType) {
        return []
      }
      const labels = getEntryActionOptions(this.targetSns, this.campaignType)
      return labels.map(item => ({ label: item.label, value: item.entryActionType }))
    },
    campaignTypeDisabled() {
      const accountId = this.getAccountIdForTargetSns(this.account)
      return !this.targetSns && !accountId
    },
    entryActionDisabled() {
      return !this.campaignType
    }
  },
  watch: {
    // グループ変更時に検索フィルターを閉じる
    currentGroupId() {
      this.showCampaignFilter = false
    },
    validationDatetime: {
      handler: 'validationDatetime'
    },
    account: {
      handler: 'selectedTargetSns'
    },
    targetSns() {
      if (this.isLoadingFormFromQuery) {
        return
      }
      this.campaignType = null
      this.entryActionTypes = []
    },
    campaignType() {
      if (this.isLoadingFormFromQuery) {
        return
      }
      this.entryActionTypes = []
    },
    '$route.query': {
      handler() {
        this.restoreFromQuery()
        // 検索条件がある場合は自動的にパネルを開く
        if (hasSearchConditions(this.$route.query)) {
          this.showCampaignFilter = true
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ...mapActions(useCampaignAccountStore, ['fetchCampaignAccounts']),
    ...mapActions(useCampaignStore, ['setLastQueryParams']),

    /**
     * クエリパラメータから検索条件を復元
     */
    restoreFromQuery() {
      this.isLoadingFormFromQuery = true
      const query = this.$route.query

      const formState = extractFormStateFromQuery(query)
      this.title = formState.title
      this.status = formState.status
      this.targetSns = formState.targetSns
      this.campaignType = formState.campaignType
      this.entryActionTypes = formState.entryActionTypes

      // 日時の復元
      if (query.startDatetime) {
        const startMoment = moment(query.startDatetime, 'YYYY-MM-DD-HH-mm')
        this.startDate = startMoment.format('YYYY-MM-DD')
        this.startTime = startMoment.format('HH:mm')
      } else {
        this.startDate = undefined
        this.startTime = undefined
      }

      if (query.endDatetime) {
        const endMoment = moment(query.endDatetime, 'YYYY-MM-DD-HH-mm')
        this.endDate = endMoment.format('YYYY-MM-DD')
        this.endTime = endMoment.format('HH:mm')
      } else {
        this.endDate = undefined
        this.endTime = undefined
      }

      // 復元した日付がzodバリデーションに失敗する場合はクリア
      const dateValidation = dateSchema.safeParse({
        startDate: this.startDate,
        startTime: this.startTime,
        endDate: this.endDate,
        endTime: this.endTime
      })

      if (!dateValidation.success) {
        // 6ヶ月制限または其の他のバリデーション違反の場合はフォームをクリア
        const hasDateRangeError = dateValidation.error.issues.some(
          issue =>
            issue.message === '日付範囲は6ヶ月以内で設定してください' ||
            issue.message === '終了日時は開始日時より後に設定してください'
        )

        if (hasDateRangeError) {
          this.startDate = undefined
          this.startTime = undefined
          this.endDate = undefined
          this.endTime = undefined
        }
      }

      // アカウントの復元（存在チェック付き）
      if (query.campaignAccountId && this.accounts.length > 0) {
        const account = this.accounts.find(acc => this.getAccountIdForTargetSns(acc) === query.campaignAccountId)
        if (account) {
          this.account = account
        } else {
          // 存在しないアカウントIDの場合は「指定なし」に設定し、クエリパラメータを削除
          this.account = this.accounts.find(acc => acc.name === '指定なし') || {}
          this.removeInvalidQueryParam('campaignAccountId')
        }
      } else {
        this.account = this.accounts.find(acc => acc.name === '指定なし') || {}
      }

      // ステータス・SNSタイプ・キャンペーンタイプに不正な値があった場合もクエリパラメータを削除
      if (query.status && !CampaignStatusTypeSchema.safeParse(query.status).success) {
        this.removeInvalidQueryParam('status')
      }
      if (query.targetSns && !CampaignTargetSnsTypeSchema.safeParse(query.targetSns).success) {
        this.removeInvalidQueryParam('targetSns')
      }
      if (query.campaignType && !CampaignTypeSchema.safeParse(query.campaignType).success) {
        this.removeInvalidQueryParam('campaignType')
      }

      this.$nextTick(() => {
        this.isLoadingFormFromQuery = false
      })
    },

    /**
     * 不正なクエリパラメータを削除
     */
    removeInvalidQueryParam(paramName) {
      const currentQuery = { ...this.$route.query }
      delete currentQuery[paramName]

      // 不正なパラメータを含むURLを修正
      this.$router.replace({ query: currentQuery }).catch(() => {
        // ナビゲーションエラーを無視
      })
    },

    /**
     * クエリパラメータを更新してページ遷移
     */
    updateQueryParams(newParams) {
      const currentQuery = { ...this.$route.query }
      const updatedQuery = { ...currentQuery, ...newParams }

      // 値がundefinedまたは空文字の場合は削除
      Object.keys(updatedQuery).forEach(key => {
        if (updatedQuery[key] === undefined || updatedQuery[key] === '') {
          delete updatedQuery[key]
        }
      })

      // クエリパラメータをストアに保存してからページ遷移
      this.setLastQueryParams(updatedQuery)
      this.$router.push({ query: updatedQuery })
    },

    /**
     * アカウントのIDを取得
     */
    getAccountIdForTargetSns(account) {
      switch (account.target_sns) {
        case 'twitter':
          return account.account_id
        case 'instagram':
          return account.ig_id
        case 'tiktok':
          return account.tt_account_id
        default:
          return undefined
      }
    },
    updateTitleValue(value) {
      this.title = value
    },
    updateTargetSnsValue(value) {
      this.targetSns = value
    },
    updateStatusValue(value) {
      this.status = value
    },
    updateCampaignTypeValue(value) {
      this.campaignType = value
    },
    toggleShowCampaignFilter() {
      this.showCampaignFilter = !this.showCampaignFilter
      this.blurForCampaignFilterButton()
    },

    /**
     * 検索条件をクリア
     */
    clearSearch() {
      if (confirm('検索条件をクリアしてもよろしいですか？')) {
        TrackingService.sendEvent('click:キャンペーン一覧|キャンペーン検索|クリア')
        this.$router.push({ query: {} })
      }
    },
    async selectedAccountIdForMyTargetSns(account) {
      switch (this.account.target_sns) {
        case 'twitter':
          return account.account_id
        case 'instagram':
          return account.ig_id
        case 'tiktok':
          return account.tt_account_id
        default:
          return undefined
      }
    },
    selectedTargetSns() {
      if (!this.account) {
        return
      }

      switch (this.account.target_sns) {
        case 'twitter':
          this.targetSns = 'twitter'
          break
        case 'instagram':
          this.targetSns = 'instagram'
          break
        case 'tiktok':
          this.targetSns = 'tiktok'
          break
      }
    },
    async searchCampaign() {
      TrackingService.sendEvent('click:キャンペーン一覧|キャンペーン検索|検索を実行')

      const searchParams = {
        targetSns: this.targetSns || undefined,
        campaignAccountId: this.getAccountIdForTargetSns(this.account) || undefined,
        title: this.title || undefined,
        status: this.status || undefined,
        startDatetime: this.startDatetime || undefined,
        endDatetime: this.endDatetime || undefined,
        campaignType: this.campaignType || undefined,
        entryActionTypes: this.entryActionTypes?.length > 0 ? this.entryActionTypes.join(',') : undefined,
        page: undefined // 検索時はページをリセット
      }

      this.updateQueryParams(searchParams)
    },
    blurForCampaignFilterButton() {
      this.$refs.campaignFilterButton.$el.blur()
    }
  },
  async created() {
    await this.fetchCampaignAccounts()

    const initialAccount = {
      name: '指定なし',
      picture_url: undefined,
      target_sns: undefined
    }
    this.accounts = [initialAccount, ...this.apiAccounts]

    // 初期化後にクエリパラメータから復元
    this.restoreFromQuery()
  }
})
</script>
<style lang="scss" scoped>
@use 'sass:math';
@use '@/client/assets/scss/variables.scss' as *;

.campaign-filter {
  width: 100%;
}

.campaign-filter-account-dropdown-link {
  display: flex;
  align-items: center;
  height: $spacing-unit * 5;
  padding: $spacing-unit;
  cursor: pointer;
  border: 1px solid $border-color;
  border-radius: math.div($spacing-unit, 2);

  span {
    width: $spacing-unit * 25;
  }

  &:hover {
    border: 1px solid #bdbdbd;
  }

  &:focus {
    border: 1px solid $primary-color;
  }
}

.campaign-filter-button {
  padding-right: 0 !important;
  color: $link-color !important;
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;

  &:focus {
    opacity: 0.6 !important;
  }

  &:hover {
    opacity: 0.6 !important;
  }

  :deep(.mdi.mdi-arrow-down-drop-circle-outline) {
    margin: 0;
  }

  :deep(.mdi.mdi-arrow-up-drop-circle-outline) {
    margin: 0;
  }
}

.campaign-filter-container {
  margin-bottom: $spacing-unit * 2;
}

.campaign-filter-row {
  gap: $spacing-unit;

  :deep(.el-input__icon.mdi.mdi-clock) {
    vertical-align: -40%;
  }

  :deep(.el-input__icon.mdi.mdi-calendar-today) {
    vertical-align: -40%;
  }
}

.campaign-filter-input-label {
  margin-bottom: $spacing-unit;
}

.campaign-filter-input-element {
  .el-input__inner {
    height: $spacing-unit * 5;
  }

  .account-container {
    min-width: $spacing-unit * 25;
  }

  &.title {
    .el-input__inner {
      width: $spacing-unit * 37;
    }
  }

  &.has-max-width-pulldown {
    max-width: $spacing-unit * 24;
  }

  // 応募条件プルダウン（el-select multiple + collapse-tags）
  &.has-max-width-entry-action {
    width: $spacing-unit * 28;

    :deep(.el-select__tags) {
      flex-wrap: nowrap;
      overflow: hidden;
    }

    :deep(.el-tag:first-child) {
      max-width: 75%;
    }

    :deep(.el-select__tags-text) {
      display: inline-block;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: middle;
      white-space: nowrap;
    }
  }
}

.campaign-filter-date-time-label-suffix {
  display: flex;
  align-items: center;
  margin: 0 $spacing-unit * 2 0 $spacing-unit;
}

.campaign-filter-date-time-validation-message {
  color: $danger-color;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.2s ease;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
  transform: translateY(-50px);
}

.el-dropdown-menu {
  max-height: 50 * $spacing-unit;
  overflow-y: auto;

  .account-item {
    padding: $spacing-unit 0;
  }
}

.campaign-filter-action-row {
  display: flex;
  gap: $spacing-unit;
  justify-content: flex-end;
  margin-top: $spacing-unit * 2;
}
</style>
